"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _layout = require("../layout");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// This uses ul instead of ol because the numbering of the list
// wouldn't match the actual page numbers, due to the navigation
// buttons and ellipsis items.
var PaginationContainer = ( /*#__PURE__*/0, _styledBase.default)(_layout.Row.withComponent('ul', {
  target: "e1x844ot1"
}), {
  target: "e1x844ot0"
})(process.env.NODE_ENV === "production" ? {
  name: "1e0c5a4",
  styles: "flex-wrap:wrap;list-style-type:none;padding:0;margin:0;"
} : {
  name: "1e0c5a4",
  styles: "flex-wrap:wrap;list-style-type:none;padding:0;margin:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL3BhZ2luYXRpb24vUGFnaW5hdGlvbkNvbnRhaW5lci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTzRCIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL3BhZ2luYXRpb24vUGFnaW5hdGlvbkNvbnRhaW5lci50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IFJvdyB9IGZyb20gJy4uL2xheW91dCc7XG5cbi8vIFRoaXMgdXNlcyB1bCBpbnN0ZWFkIG9mIG9sIGJlY2F1c2UgdGhlIG51bWJlcmluZyBvZiB0aGUgbGlzdFxuLy8gd291bGRuJ3QgbWF0Y2ggdGhlIGFjdHVhbCBwYWdlIG51bWJlcnMsIGR1ZSB0byB0aGUgbmF2aWdhdGlvblxuLy8gYnV0dG9ucyBhbmQgZWxsaXBzaXMgaXRlbXMuXG5jb25zdCBQYWdpbmF0aW9uQ29udGFpbmVyID0gc3R5bGVkKFJvdy53aXRoQ29tcG9uZW50KCd1bCcpKSh7XG4gIGZsZXhXcmFwOiAnd3JhcCcsXG4gIGxpc3RTdHlsZVR5cGU6ICdub25lJyxcbiAgcGFkZGluZzogMCxcbiAgbWFyZ2luOiAwXG59KTtcblxuUGFnaW5hdGlvbkNvbnRhaW5lci5kaXNwbGF5TmFtZSA9ICdQYWdpbmF0aW9uQ29udGFpbmVyJztcblxuUGFnaW5hdGlvbkNvbnRhaW5lci5kZWZhdWx0UHJvcHMgPSB7XG4gIC4uLihSb3cuZGVmYXVsdFByb3BzIGFzIGFueSksXG4gIGFsaWduSXRlbXM6ICdjZW50ZXInLFxuICBncmlkR2FwOiA0LFxuICByb2xlOiAnbGlzdCdcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFBhZ2luYXRpb25Db250YWluZXI7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
PaginationContainer.displayName = 'PaginationContainer';
PaginationContainer.defaultProps = _objectSpread(_objectSpread({}, _layout.Row.defaultProps), {}, {
  alignItems: 'center',
  gridGap: 4,
  role: 'list'
});
var _default = PaginationContainer;
exports.default = _default;